import React from 'react';
import { Link } from 'react-router-dom';

import { address, highlightMatches } from '../helpers';
import { fromISO } from '../../../../../lib/utils/datetime_formatters';

export default function OrderHit({ hit }) {
  const clipOrderKey = (key) => {
    if (key.length > 13) return `${key.substring(0, 13)}...`;

    return key;
  };

  return (
    <article className="py-3 border-b w-full" key={hit.id} id='search_result'>
      <Link
        className="text-lg font-avenir-black text-primary-blue cursor-pointer flex"
        to={`/orders/${hit.order_key}`}
      >
        <span className="underline">{clipOrderKey(hit.order_key)}</span>
        <span className="inline-flex items-center rounded-md ml-2 mb-1 px-3 py-0.5 pt-[0.2rem] capitalize font-avenir-book text-xs tracking-wide bg-blue-100 text-primary-blue">
          Order
        </span>
      </Link>
      <div className="capitalize grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-6">
        <div className="text-sm font-avenir-book">
          <p>ID: {hit.id}</p>
          <p>Created: {fromISO(hit.created_at).toLocaleString()}</p>
          Match: {highlightMatches(hit)}
        </div>
        <p className="text-sm">
          <span className="block">
            Owner: {hit.first_name} {hit.last_name}
          </span>
          <span className="block">
            Shipping Address: {address(hit.shipping_address)}
          </span>
        </p>
        <div className="text-sm">
          <div>
            <p>Status: {hit.status}</p>
            <p>Type: {hit.product_type.replace('_', ' ')}</p>
          </div>
        </div>
      </div>
    </article>
  );
}
